import Link from "@/components/link";
import Image from "@/components/image";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/footer";
import { useDocumentTitle } from "@/lib/use-document-title";

export default function Sammy() {
  useDocumentTitle("miniSAM - Distilled Segment Anything Model");

  return (
    <main className="min-h-screen bg-white flex flex-col">
      {/* Full-width cover image with increased height (80vh) */}
      <div className="w-full h-[80vh] relative">
        {/* Back to home link positioned over the image */}
        <div className="absolute top-8 left-8 z-10">
          <Link
            href="/"
            className="inline-flex items-center text-white hover:text-gray-200 transition-colors"
          >
            <ArrowLeft size={16} className="mr-2" />
            Back to home
          </Link>
        </div>

        <Image
          src="/images/sammy.png"
          alt="miniSAM - Distilled Segment Anything Model"
          fill
          className="object-cover"
          priority
        />
      </div>

      <div className="container mx-auto py-8 px-4 md:px-6 flex-grow">
        <div className="max-w-4xl mx-auto">
          <p className="text-xl italic text-center mb-12">
            Distilling Segment Anything and making it usable without a GPU
          </p>

          <article className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold mb-2">The Challenge</h2>
            <p className="mb-6">
              Meta's Segment Anything Model (SAM) is powerful but
              resource-intensive, making it impractical for browsers and devices
              without GPUs. Currently, there are no plug-and-play segmentation
              packages for the web.
            </p>

            <h2 className="text-2xl font-bold mb-2">The Solution</h2>
            <p className="mb-6">
              miniSAM distills SAM's Vision Transformer into a TinyViT variant
              that runs entirely in-browser while maintaining impressive
              segmentation capabilities.
            </p>

            <h2 className="text-2xl font-bold mb-2">Technical Approach</h2>
            <ul className="mb-6">
              <li>Optimized architecture with reduced parameters</li>
              <li>Knowledge distillation training techniques</li>
              <li>Browser-optimized inference pipeline</li>
              <li>Packaged as a simple Node.js module</li>
            </ul>

            <p className="text-sm text-gray-500 italic mt-8">
              Live demo and documentation coming soon
            </p>
          </article>
        </div>
      </div>

      <Footer />
    </main>
  );
}
